<script setup lang="ts">
window.opener?.postMessage("cancel", window.location.origin);
window.close();
</script>

<template>
  <div>処理の中断を待っています。しばらくおまちください......</div>
</template>
